import { Channel } from "pusher-js";

import Task, { Status } from "model/data/task";

import client from "domain/shared/graphql/client";

import { TaskResponse, TasksQuery } from "./queries";
import { changeStatus } from "./mutation";
import { kanvasPusher } from "../pusher";

import AsyncStorage from "@react-native-async-storage/async-storage";
import { USER_ROLES_STORE_KEY } from "domain/shared/services/graph-user-service";

export default class TasksApi {
  async get(leadId: number, taskListId?: number): Promise<Task[]> {
    try {
      const response = await client.query<{ leadTaskItems: { data: TaskResponse[] } }>({ 
        query: TasksQuery,
        fetchPolicy: 'network-only',
        variables:  { leadId, taskListId }
      });

      const userRolesToFormat = await AsyncStorage.getItem(USER_ROLES_STORE_KEY)
      const userRoles = JSON.parse(userRolesToFormat ?? "[]")

      const { data } = response.data.leadTaskItems;
      return data.map((item) => Task.fromGraph(item, userRoles)).filter((item) => !item.config.hide);
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  getSubscription(leadId: number, fn: () => void): VoidFunction {
    const channel = kanvasPusher.subscribe(`lead-tasks-${leadId}`);
    const bind = channel.bind('lead.tasks', fn);
    return () => {
      channel.unsubscribe();
      bind.unbind();
    };
  }

  async changeStatus(id: number, leadId: number, status: Status, messageId?: number, config?: any) {
    const response = await client.mutate<{ changeTaskEngagementItemStatus: boolean }>({
      mutation: changeStatus,
      variables: { id, leadId, status, messageId, config }
    });

    if (!response.data) return false;

    const { changeTaskEngagementItemStatus } = response.data;

    return changeTaskEngagementItemStatus;
  }
}